import { useCallback } from 'react';
import { useIntercom } from 'react-use-intercom';

import { IntercomOnboardingStepAttributeKey } from 'constants/IntercomCustomAttributeKey';
import { WizardStepName } from 'data/ppoints/constants';

const STEP_NAME_TO_ATTRIBUTE_KEY: Record<WizardStepName, IntercomOnboardingStepAttributeKey> = {
    [WizardStepName.choose_service_provider]: IntercomOnboardingStepAttributeKey.Provider,
    [WizardStepName.shipping_zone_rate]: IntercomOnboardingStepAttributeKey.ShippingZone,
    [WizardStepName.integration_mode_step]: IntercomOnboardingStepAttributeKey.Integration,
    [WizardStepName.app_extensions]: IntercomOnboardingStepAttributeKey.AppEmbeds,
    [WizardStepName.summary]: IntercomOnboardingStepAttributeKey.Subscribe,
};

type UpdateIntercomOnboardingStep = (stepName: WizardStepName) => void;

/**
 * Mirrors the setup guide step done reporting into Intercom: a finished wizard
 * step sets its matching onboarding_step_* custom attribute to true.
 */
export const useUpdateIntercomOnboardingStep = (): UpdateIntercomOnboardingStep => {
    const { update } = useIntercom();

    return useCallback(
        (stepName: WizardStepName): void => {
            const attributeKey = STEP_NAME_TO_ATTRIBUTE_KEY[stepName];
            if (!attributeKey) return;

            try {
                update({
                    customAttributes: {
                        [attributeKey]: true,
                    },
                });
            } catch (error) {
                console.error('Error in useUpdateIntercomOnboardingStep:', error);
            }
        },
        [update]
    );
};
